import React, { useState } from "react"
import { createModel } from "hox";
import { IHistoryParams, IHistoryDetail, ICatalogSearch } from "./dataHistoryTypes"
import {historyService} from "./dataHistoryService"
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { filterArrId, Optios, transPgToPagination } from "../../../utils/utils"

export const useHistoryModel = createModel(function () {
    const initSearchParams: IHistoryParams = {}
    const initDataSource: IHistoryDetail[] = []
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IHistoryParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<IHistoryDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    //表格选中行key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<IHistoryDetail>({})    
    const upDataSearchParam = (upDataParam: IHistoryParams) => {
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        loadData(resetPage, initSearchParams)
    }    
    const loadData = async (pages?:ISearchPage,data?:IHistoryParams)=>{
        const searchParams = data ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await historyService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        setDataSource(records)
    }
    return {
        searchParam,
        dataSource,
        page,
        selectedRowKeys,
        selectedRow,
        setSearchParam,
        setDataSource,
        setPage,
        loadData,
        resetSearchParam,
        upDataSearchParam,
        setSelectedRowKeys,
        setSelectedRow
    }
});